export default function formatString(
  template: string,
  ...args: (string | number)[]
): string {
  return template.replace(/{(\d+)}/g, (match, index) => {
    const arg = args[parseInt(index, 10)];
    return arg !== undefined ? String(arg) : match;
  });
}
